import AdminSubmissions from "components/adminStartup/Submissions";
import RBACSwitcher from "components/common/Auth/RBACSwitcher";
import StudentSubmissions from "components/students/Submissions";
import TeacherSubmissions from "../components/teachers/submission";

const Submissions = () => {
  return (
    <RBACSwitcher
      admin={<AdminSubmissions />}
      student={<StudentSubmissions />}
      teacher={<TeacherSubmissions />}
      school={<div>Sub Admin ecoles</div>}
    />
  );
};

export default Submissions;
